import { AuthenticationConfig } from '@/core/components/authentication/authentication.module';
import { AUTHENTICATION_CONFIG } from '@/core/components/authentication/injection-tokens';
import { ExtendedAuthenticationService } from '@/core/components/authentication/services/extended-authentication.service';
import { Inject, Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedGuard  {
  constructor(protected authenticationService: ExtendedAuthenticationService, protected router: Router, @Inject(AUTHENTICATION_CONFIG) protected authenticationConfig: AuthenticationConfig) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (! this.authenticationService.isAuthenticated())
      this.router.navigate([this.authenticationConfig.loginUrl], { queryParams: { redirect: state.url }, replaceUrl: true });

    return true;
  }
}
